import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { RETRY_TRANSIENT } from "../../apollo/provider/createTransientRetryLink";
import { type PayoutStatsInput, type PayoutStatsResponse, type PayoutSummary } from "../../gql-generated/types";
import { getPayoutStatsSummary } from "../api/queries/getPayoutStatsSummary";

interface UsePayoutStatsSummaryParams {
    startDate?: string;
    endDate?: string;
    countryFilters: string[];
    unlockableId?: string;
    skip?: boolean;
}

interface UsePayoutStatsSummaryResult {
    loading: boolean;
    error?: Error;
    data?: PayoutSummary | null;
}

export const usePayoutStatsSummary = ({
    startDate,
    endDate,
    countryFilters,
    unlockableId,
    skip,
}: UsePayoutStatsSummaryParams): UsePayoutStatsSummaryResult => {
    const input: PayoutStatsInput = {
        startDate,
        endDate,
        countryFilters,
        unlockableId,
        summary: { _unused: true },
    };

    const { data, loading, error } = useQuery<{ payoutStats: PayoutStatsResponse }>(getPayoutStatsSummary, {
        variables: { input },
        skip,
        context: RETRY_TRANSIENT,
    });

    const summary = useMemo(() => data?.payoutStats.summary, [data?.payoutStats.summary]);

    return {
        loading,
        error,
        data: summary,
    };
};
